<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>Расчет расходов на компенсационные выплаты (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="saving" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >


        <div class="col-md-12" v-if="getNotAddedCategories().length > 0">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="lastname" class="form-label col-md-5">
                В таблицу добавить категория должностей
              </label>
              <div class="col-md-7">
                <select v-model="selectedCategory" id="category"
                        class="form-select">
                  <option v-for="category in getNotAddedCategories()" :key="category" :value="category">
                    {{ categories[category] }}
                  </option>
                </select>

              </div>

              <div class="col-md-2">
                <b-button variant="success" class="btn-sm" style="margin-left: 20px; margin-top: 2px;"
                          :disabled="!selectedCategory"
                          @click="addSelectedCategoryInfo()">
                  Добавить
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr>

              <th rowspan="3" class="title-cell">Категория должностей</th>
              <th rowspan="3">Сумма пособий на оздоравление в год</th>
              <th colspan="4">в том числе</th>
              <th rowspan="2" colspan="2">Аренда жилья (оплата найма)</th>
              <th rowspan="2" colspan="2">Коммунальные расходы по жилью</th>
              <th rowspan="2" colspan="2">Переезд и обустройство</th>
              <th rowspan="2" colspan="2">Материальная помощь и прочее</th>
              <th rowspan="3">Итого по специфике 113</th>
              <th rowspan="3" style="width: 50px"></th>
            </tr>
            <tr>
              <th colspan="2">Пособие на оздоровление государственных и гражданских служащих (леч.пособие к отпуску)</th>
              <th colspan="2">Пособия на оздоровление работникам, проживающим в зонах экологического бедствия</th>
            </tr>
            <tr>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
              <th>среднее кол-во работников (единиц)</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row">
              <td>ВСЕГО</td>
              <td>{{ dto.annualHealthBenefitAmount }}</td>
              <td>{{ dto.healthBenefitGovEmployeesAverageCount }}</td>
              <td>{{ dto.healthBenefitGovEmployeesAmount }}</td>
              <td>{{ dto.ecoDisasterZoneBenefitAverageCount }}</td>
              <td>{{ dto.ecoDisasterZoneBenefitAmount }}</td>
              <td>{{ dto.housingRentAverageCount }}</td>
              <td>{{ dto.housingRentAmount }}</td>
              <td>{{ dto.housingUtilitiesAverageCount }}</td>
              <td>{{ dto.housingUtilitiesAmount }}</td>
              <td>{{ dto.relocationSetupAverageCount }}</td>
              <td>{{ dto.relocationSetupAmount }}</td>
              <td>{{ dto.materialAssistanceAverageCount }}</td>
              <td>{{ dto.materialAssistanceAmount }}</td>
              <td>{{ dto.totalSpecific113Amount }}</td>
              <td></td>
            </tr>
            <template v-for="category in dto.categories">
              <tr class="total-row calculated-row">
                <td>{{ categories[category.type] }}</td>
                <td>{{ category.annualHealthBenefitAmount }}</td>
                <td>{{ category.healthBenefitGovEmployeesAverageCount }}</td>
                <td>{{ category.healthBenefitGovEmployeesAmount }}</td>
                <td>{{ category.ecoDisasterZoneBenefitAverageCount }}</td>
                <td>{{ category.ecoDisasterZoneBenefitAmount }}</td>
                <td>{{ category.housingRentAverageCount }}</td>
                <td>{{ category.housingRentAmount }}</td>
                <td>{{ category.housingUtilitiesAverageCount }}</td>
                <td>{{ category.housingUtilitiesAmount }}</td>
                <td>{{ category.relocationSetupAverageCount }}</td>
                <td>{{ category.relocationSetupAmount }}</td>
                <td>{{ category.materialAssistanceAverageCount }}</td>
                <td>{{ category.materialAssistanceAmount }}</td>
                <td>{{ category.totalSpecific113Amount }}</td>
                <td>
                  <el-button type="text" class="btn-icon color-red"
                             @click="onClickRemove(category)">
                    <font-awesome-icon :icon="['fas', 'cancel']"/>
                  </el-button>
                </td>
              </tr>
              <tr v-for="month in category.items">
                <td>
                  {{ months[month.month - 1] }}
                </td>
                <td class="expense-sum-edit">
                  {{month.annualHealthBenefitAmount}}
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.healthBenefitGovEmployeesAverageCount" type="number"                            @input="recalculate(category, month, 'healthBenefitGovEmployeesAverageCount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.healthBenefitGovEmployeesAmount" type="number"                            @input="recalculate(category, month, 'healthBenefitGovEmployeesAmount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.ecoDisasterZoneBenefitAverageCount" type="number"                            @input="recalculate(category, month, 'ecoDisasterZoneBenefitAverageCount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.ecoDisasterZoneBenefitAmount" type="number"                            @input="recalculate(category, month, 'ecoDisasterZoneBenefitAmount')"/>
                </td>

                <td class="expense-sum-edit">
                  <el-input v-model="month.housingRentAverageCount" type="number"                            @input="recalculate(category, month, 'housingRentAverageCount')"/>
                </td>

                <td class="expense-sum-edit">
                  <el-input v-model="month.housingRentAmount" type="number"                            @input="recalculate(category, month, 'housingRentAmount')"/>
                </td>

                <td class="expense-sum-edit">
                  <el-input v-model="month.housingUtilitiesAverageCount" type="number"                            @input="recalculate(category, month, 'housingUtilitiesAverageCount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.housingUtilitiesAmount" type="number"                            @input="recalculate(category, month, 'housingUtilitiesAmount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.relocationSetupAverageCount" type="number"                            @input="recalculate(category, month, 'relocationSetupAverageCount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.relocationSetupAmount" type="number"                            @input="recalculate(category, month, 'relocationSetupAmount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.materialAssistanceAverageCount" type="number"                            @input="recalculate(category, month, 'materialAssistanceAverageCount')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.materialAssistanceAmount" type="number"  @input="recalculate(category, month, 'materialAssistanceAmount')"/>
                </td>


                <td > {{ month.totalSpecific113Amount }} </td>
                <td>

                </td>
              </tr>
            </template>

            </tbody>

          </table>
        </div>


      </form>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'treatment-benefit',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        categories: []
      },
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      selectedCategory: null,
      categories: {
        ADMINISTRATIVE_STAFF: "Адм.упр.персонала",
        TEACHING_STAFF: "Пед.персонал",
        SUPPORT_STAFF: "Учебно вспом-й персонал",
        SERVICE_STAFF: "Обслуживающий и прочий персонал",
      }, 
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: [1, 2, 3, 4],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },
    getNotAddedCategories() {
      if (!this.dto.categories) {
        return this.categories;
      }
      if (this.dto.categories.length >= Object.keys(this.categories).length) {
        return [];
      }
      const addedCategories = this.dto.categories.map(c => c.type);
      const notAddedCategories = [];
      Object.keys(this.categories).forEach(key => {
        if (!addedCategories.includes(key)) {
          notAddedCategories.push(key);
        }
      });
      return notAddedCategories;
    },
   addSelectedCategoryInfo() {

      const months = [];
      for (let i = 1; i <= 12; i++) {
        months.push({month: i})
      }

      this.dto.categories.push({
        type: this.selectedCategory,
        items: months
      });
    },
    async findById(uuid) {
      this.isLoading = true;
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.sortByCatAndMonth();
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;


        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.sortByCatAndMonth();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    sortByCatAndMonth() {
      if (!this.dto.categories) {
        return;
      }
      this.dto.categories.forEach(category => {
        if (category.items && category.items.length > 0) {
          category.items.sort((a, b) => a.month - b.month);
        }
      });
      this.dto.categories.sort((a, b) => {
        const order = ['ADMINISTRATIVE_STAFF', 'TEACHING_STAFF', 'SUPPORT_STAFF', 'SERVICE_STAFF'];
        return order.indexOf(a.type) - order.indexOf(b.type);
      });
    },

    goBack()  {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED'  || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    async onClickRemove(category) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.uuid, category.uuid);

          this.dto.categories = this.dto.categories.filter(c => c.uuid !== category.uuid);
          this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
          this.sortByCatAndMonth();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
     recalculate(cat, month, fieldName) {
        if (!cat.items || cat.items.length === 0) return;
        for (const item of cat.items) {
          item.annualHealthBenefitAmount = parseFloat(item.healthBenefitGovEmployeesAmount || 0) + parseFloat(item.ecoDisasterZoneBenefitAmount || 0);
          item.totalSpecific113Amount = parseFloat(item.annualHealthBenefitAmount || 0) +
            parseFloat(item.housingRentAmount || 0) +
            parseFloat(item.housingUtilitiesAmount || 0) +
            parseFloat(item.relocationSetupAmount || 0) +
            parseFloat(item.materialAssistanceAmount || 0);
        }


        for (const cat of this.dto.categories) {
          cat[fieldName] = cat.items.reduce((sum, item) => sum + parseFloat(item[fieldName] || 0), 0);
        }

       cat.annualHealthBenefitAmount = cat.items.reduce((sum, i) => sum + parseFloat(i.annualHealthBenefitAmount || 0), 0);
       cat.totalSpecific113Amount = cat.items.reduce((sum, i) => sum + parseFloat(i.totalSpecific113Amount || 0), 0);
       this.dto[fieldName] = this.dto.categories.reduce((sum, c) => sum + parseFloat(c[fieldName] || 0), 0);
       this.dto.annualHealthBenefitAmount = this.dto.categories.reduce((sum, i) => sum + parseFloat(i.annualHealthBenefitAmount || 0), 0);
       this.dto.totalSpecific113Amount = this.dto.categories.reduce((sum, i) => sum + parseFloat(i.totalSpecific113Amount || 0), 0);
     }

  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}


.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 250px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
:deep(.el-input__inner) { text-align: right; font-size: 13px;   min-width: 100px;}
.total-row td {
  font-weight: bold;
}
</style>
